var _circle, _path, _path2, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceChargeNewFeatureIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#27AE60",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3148 15.8993V12.6576C14.3148 12.2903 14.1939 11.9495 13.99 11.6741H25.634C26.0996 11.6741 26.5234 11.8647 26.8301 12.1714C27.1369 12.4774 27.3271 12.9009 27.3271 13.3675V28.9629H14.3146L14.3148 15.8993ZM24.9328 14.7234C25.1187 14.7234 25.2695 14.5726 25.2695 14.3867C25.2695 14.2008 25.1187 14.0499 24.9328 14.0499H16.7093C16.5234 14.0499 16.3726 14.2008 16.3726 14.3867C16.3726 14.5726 16.5234 14.7234 16.7093 14.7234H24.9328ZM24.9328 17.0726C25.1187 17.0726 25.2695 16.9217 25.2695 16.7358C25.2695 16.5499 25.1187 16.3991 24.9328 16.3991H16.7093C16.5234 16.3991 16.3726 16.5499 16.3726 16.7358C16.3726 16.9217 16.5234 17.0726 16.7093 17.0726H24.9328ZM24.9325 19.4214C25.1184 19.4214 25.2692 19.2705 25.2692 19.0846C25.2692 18.8987 25.1184 18.7479 24.9325 18.7479H16.709C16.5231 18.7479 16.3722 18.8987 16.3722 19.0846C16.3722 19.2705 16.5231 19.4214 16.709 19.4214H24.9325ZM13.6409 15.89V18.0432H11.6738V12.6569C11.6738 12.3933 11.7778 12.1533 11.9469 11.9772L11.9629 11.9623C12.1381 11.787 12.3795 11.6769 12.645 11.6735H12.6704C12.9355 11.6769 13.1766 11.787 13.352 11.9623C13.5302 12.1405 13.6411 12.3866 13.6411 12.6569L13.6409 15.89ZM13.6409 18.7167V29.299C13.6409 29.4849 13.7917 29.6357 13.9776 29.6357H27.6633C27.8492 29.6357 28 29.4849 28 29.299V13.3668C28 12.7158 27.7341 12.1244 27.3057 11.6958C26.8772 11.2659 26.285 11 25.6333 11H12.6574L12.6466 11.0003C12.1944 11.0033 11.7839 11.1886 11.4863 11.4861L11.4672 11.5071C11.1781 11.806 11 12.2121 11 12.6571V18.3798C11 18.5657 11.1508 18.7165 11.3367 18.7165L13.6409 18.7167Z",
    fill: "#419364",
    stroke: "#419364",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2734 21.4102L19.8734 27.3602",
    stroke: "#419364",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.3219,
    cy: 25.8727,
    r: 0.925,
    fill: "#419364",
    stroke: "#419364",
    strokeWidth: 0.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9234,
    cy: 22.4742,
    r: 0.925,
    fill: "#419364",
    stroke: "#419364",
    strokeWidth: 0.7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceChargeNewFeatureIcon);
export default __webpack_public_path__ + "static/media/ServiceChargeNewFeatureIcon.fe7a52d26856dd193dcc77bfa13a3bd5.svg";
export { ForwardRef as ReactComponent };